document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.c-club-videos__modal');
  if (!modal) return;

  const triggers = document.querySelectorAll('[data-modal-trigger]');
  const closeBtns = document.querySelectorAll('[data-modal-close]');
  const sliderEl = modal.querySelector('[data-modal-slider]');
  let swiperInstance = null;

  const enableSlider = modal.getAttribute('data-enable-slider') === 'true';

  function initSwiper(initialIndex) {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
    }

    // We assume Swiper is globally available as expected in Shopify architecture
    swiperInstance = new Swiper(sliderEl, {
      initialSlide: initialIndex,
      slidesPerView: 1,
      allowTouchMove: enableSlider,
      navigation: enableSlider ? {
        nextEl: '.c-club-videos__modal-next',
        prevEl: '.c-club-videos__modal-prev',
      } : false,
      on: {
        slideChange: () => {
          pauseAllVideos();
          // Provide a tiny delay for Swiper to finish updating DOM classes,
          // but if it fails autoplay, it's due to gesture limits. 
          // Usually dragging counts as a gesture.
          setTimeout(() => {
            playCurrentVideo();
          }, 10);
        }
      }
    });

    if (!enableSlider) {
      const nextBtn = document.querySelector('.c-club-videos__modal-next');
      const prevBtn = document.querySelector('.c-club-videos__modal-prev');
      if (nextBtn) nextBtn.style.display = 'none';
      if (prevBtn) prevBtn.style.display = 'none';
    }

    // Play the video synchronously so browser allows autoplay from user click
    playCurrentVideo();
  }

  function pauseAllVideos() {
    const videos = modal.querySelectorAll('video');
    videos.forEach(v => {
      if (!v.paused) v.pause();
    });

    const iframes = modal.querySelectorAll('iframe');
    iframes.forEach(iframe => {
      // Basic postMessage to pause youtube/vimeo if possible, or just reset src to stop playback
      iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
  }

  function playCurrentVideo() {
    if (!swiperInstance) return;

    // Find the currently active slide
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (!activeSlide) return;

    // 1. If it's a deferred-media component that hasn't loaded yet
    const deferredMedia = activeSlide.querySelector('deferred-media');
    if (deferredMedia) {
      const isLoaded = deferredMedia.getAttribute('loaded') === 'true' || deferredMedia.hasAttribute('data-media-loaded');
      const videoElement = deferredMedia.querySelector('video, iframe');

      if (!isLoaded || !videoElement) {
        const button = deferredMedia.querySelector('.deferred-media__poster-button');
        if (button) {
          button.click();
          return; // Allow the deferred media component to handle autoplay
        }
      }
    }

    // 2. Check for native video element
    const video = activeSlide.querySelector('video');
    if (video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.warn("Autoplay prevented:", error);
        });
      }
    }

    // 3. Check for iframe (Youtube/Vimeo)
    const iframe = activeSlide.querySelector('iframe');
    if (iframe) {
      // Basic postMessage attempt to play
      iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      iframe.contentWindow.postMessage('{"method":"play"}', '*'); // Vimeo fallback
    }
  }

  function openModal(index) {
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    initSwiper(index);
  }

  function closeModal() {
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    pauseAllVideos();
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  triggers.forEach(btn => {
    btn.addEventListener('click', () => {
      const index = parseInt(btn.getAttribute('data-index') || '0', 10);
      openModal(index);
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
});
